export default "<router-outlet></router-outlet>\n<app-messages></app-messages>"